import {React,useEffect} from "react";
import "./assets/css/Covihack_Sponsors.css";
import img from "./assets/CoviHack Page assets/sponsor.jpg";
import GMC_LogoS from "./assets/CoviHack Page assets/Sponsors/GMC LogoS.png";
import interview_cake from "./assets/CoviHack Page assets/Sponsors/interview_cake.png";
import StreamYard from "./assets/CoviHack Page assets/Sponsors/StreamYard.png";
import taskade_circle_icon from "./assets/CoviHack Page assets/Sponsors/taskade-circle-icon.png";
import echoar from './assets/CoviHack Page assets/Sponsors/echoAR.png'
import xyz from './assets/CoviHack Page assets/Sponsors/xyz-logo-color.png'
import bludb from './assets/CoviHack Page assets/Sponsors/bludb.jpeg'
import dce from './assets/CoviHack Page assets/Sponsors/DCE Logo.png'
import gdsc from './assets/CoviHack Page assets/Sponsors/gdsc.svg'

import AOS from "aos";
import "aos/dist/aos.css";

const Covihack_Sponsors = () =>{
    useEffect(() => {
        AOS.init();
        AOS.refresh();
      }, []);
    return(
        <div className="sponsors">
            <div >
                <h1 className="text-center">Our Sponsors</h1>
                <div className="row d-flex flex-column">
                    <div className="col-md-12 sponsors-img" data-aos="fade-up">

                    <div className="row" style={{    flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                        <div className="gold-title">Gold</div>
                        <div className="row ">
                            <div className=" spons" ><a href="https://ggnindia.dronacharya.info/" target="_blank"><img src={dce} style={{    margin: "2rem 0",height: "9vh"}} className="spons-row-img" /></a></div>
                            <div className=" spons gdsc" ><a href="https://gdsc.community.dev/" target="_blank"><img src={gdsc} style={{height:"3vh"}} className="spons-row-img" /></a></div>
                        </div>
                    </div>
                    <div className="row">
                    <div className="silver-title">Silver</div>
                    <div className="row">
                              <div className=" spons" ><a href="https://www.instagram.com/blud.b_/" target="_blank"><img src={bludb} style={{height:"20vh"}} className="spons-row-img" /></a></div>

                                <div className="spons" ><a href="https://www.taskade.com/" target="_blank"><img src={taskade_circle_icon} style={{height:"10vh"}} className="spons-row-img" /></a></div>
                                <div className="spons" ><a href="https://www.interviewcake.com/" target="_blank"><img src={interview_cake} style={{height:"10vh"}} className="spons-row-img" /></a></div>
                                <div className="spons" ><a href="https://streamyard.com/" target="_blank" ><img src={StreamYard} style={{height:"6vh"}} className="spons-row-img" /></a></div>
                                <div className="spons" ><a href="https://givemycertificate.com/" target="_blank"><img src={GMC_LogoS} style={{height:"13vh"}} className="spons-row-img" /></a></div>
                                <div className="spons" ><a href="https://gen.xyz/" target="_blank"><img src={xyz} style={{height:"8vh"}} className="spons-row-img" /></a></div>
                                <div className="spons" ><a href="https://www.echo3d.co/" target="_blank"><img src={echoar} style={{height:"5vh",margin: "2rem 0"}} className="spons-row-img" /></a></div>
                            </div>
                    </div>
                        
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Covihack_Sponsors;